/**
 * @generated SignedSource<<3919e7214ebdd290ebc3df599439587f>>
 * @relayHash de509891a221dd45f5d66489c534dd74
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9802799bf957088e311460209477368f0f29892d6ac7a45208906e8e5d084bce

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConvoAiHomeThreadsInput = {
  promptOverride?: string | null;
  skipCache?: boolean | null;
  userId?: string | null;
};
export type rovoForYouTabThreadsListQuery$variables = {
  cloudId: string;
  experience: string;
  homeThreadsInput: ConvoAiHomeThreadsInput;
};
export type rovoForYouTabThreadsListQuery$data = {
  readonly convoai_homeThreads: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string | null;
        readonly sources: ReadonlyArray<{
          readonly __typename: string;
          readonly ari?: string;
          readonly data?: {
            readonly __typename: string;
          } | null;
          readonly url?: string;
          readonly " $fragmentSpreads": FragmentRefs<"Sources_AtlassianRovoForYou">;
        } | null> | null;
        readonly title: string | null;
      } | null;
    }> | null;
  } | null;
};
export type rovoForYouTabThreadsListQuery = {
  response: rovoForYouTabThreadsListQuery$data;
  variables: rovoForYouTabThreadsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experience"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "homeThreadsInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "homeThreadsInput",
    "variableName": "homeThreadsInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "ari"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "ConvoAiHomeThreadsThirdPartySource"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "rovoForYouTabThreadsListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiHomeThreadsResult",
        "kind": "LinkedField",
        "name": "convoai_homeThreads",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConvoAiHomeThreadsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThread",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "sources",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "Sources_AtlassianRovoForYou"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ]
                          }
                        ],
                        "type": "ConvoAiHomeThreadsFirstPartySource"
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rovoForYouTabThreadsListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiHomeThreadsResult",
        "kind": "LinkedField",
        "name": "convoai_homeThreads",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConvoAiHomeThreadsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThread",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "sources",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isConvoAiHomeThreadSource"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*: any*/)
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ]
                          }
                        ],
                        "type": "ConvoAiHomeThreadsFirstPartySource"
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9802799bf957088e311460209477368f0f29892d6ac7a45208906e8e5d084bce",
    "metadata": {},
    "name": "rovoForYouTabThreadsListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e8cd4b32268da939eb359111b9720fcb";

export default node;
